<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.facture',2) }}
                    </h3>
                </div>
            </div>

                <!-- <div class="row"> -->
                    <b-container>
                        <b-row>
                            <!-- <b-col> -->
                                <section class="container" id="appointment-table">
                                    <div class="appointment-table-header my-2 mb-4">
                                        <b-button @click="handleOnAddBill" v-if="can" class="p-2">
                                            <i class="fa fa-plus edit-icon"></i>
                                            {{ $t('message.add') }}
                                        </b-button>

                                        <div class="d-inline-block pl-2 pt-3">
                                            <b-input-group
                                                    size="sm"
                                                    class="mb-2"
                                            >
                                                <b-form-input
                                                        type="text"
                                                        size="sm"
                                                        class="p-2 h-100"
                                                        :placeholder="$t('message.filter') + '...'"
                                                        v-model="filterCriteria"
                                                ></b-form-input>
                                                <b-input-group-append>
                                                    <b-button
                                                            size="sm"
                                                            text="Button"
                                                            variant="primary"
                                                            @click="handlerOnFilterButton"
                                                    >
                                                        Go
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </div>

                                        <div v-if="paginationObject.numOfPages > 1" class="pagination-wrapper d-inline-block">
                                            <div class="pagination">
                                                <a
                                                        href="#"
                                                        :class="'prev page-numbers ' + (
                                                        paginationObject.currentPageNumber === 1
                                                            ? 'pagination-disabled'
                                                            : ''
                                                        )"
                                                        @click="_handlePaginationClick('prev')"
                                                >
                                                    <i aria-hidden="true" class="v-icon fas fa-chevron-left"></i>
                                                </a>
                                                <template v-for="(pageNumber, key) in paginationObject.listOfPageNumber()">
                                                    <template v-if="pageNumber === paginationObject.currentPageNumber">
                                                        <span
                                                                :key="key"
                                                                aria-current="page"
                                                                class="page-numbers current"
                                                        >
                                                            {{ pageNumber }}
                                                        </span>
                                                    </template>
                                                    <template v-else>
                                                        <a
                                                                href="#"
                                                                :key="key"
                                                                class="page-numbers"
                                                                @click="_handlePaginationClick(pageNumber)"
                                                        >
                                                            {{ pageNumber }}
                                                        </a>
                                                    </template>
                                                </template>
                                                <a
                                                        href="#"
                                                        class="next page-numbers"
                                                        :class="'next page-numbers ' + (
                                                        paginationObject.currentPageNumber === paginationObject.numOfPages
                                                            ? 'pagination-disabled'
                                                            : ''
                                                        )"
                                                        @click="_handlePaginationClick('next')"
                                                >
                                                    <i aria-hidden="true" class="v-icon fas fa-chevron-right"></i>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="appointment-table-content">
                                        <div class="container-fluid">
                                            <template v-if="paginationObject.display(paginationObject.currentPageNumber).length > 0">
                                                <div
                                                    v-for="(bill, key) in paginationObject.display(paginationObject.currentPageNumber)"
                                                    :key="key"
                                                    class="row appointment-item"
                                                >
                                                    <div class="col-lg-3">
                                                            <span class="appointment-label">
                                                                {{ $t('message.dateFacturation') }}
                                                            </span>
                                                        <h4 class="appointment-date">{{ billDate(bill.billDate, 'date') }}</h4>
                                                        <span class="appointment-label">
                                                                {{ $t('message.time') }}
                                                            </span>
                                                        <h4 class="appointment-hour">{{ billDate(bill.billDate, 'hour') }}</h4>
                                                    </div>
                                                    <div class="col-lg-3">
                                                        <span class="appointment-label">
                                                            {{ $t('message.nomPatient') }}
                                                        </span>
                                                        <h4
                                                                @click="onGoToMedicalFile(bill.medicalFileSlug)"
                                                                class="appointment-hour appointment-link"
                                                        >
                                                            {{ bill.patientName }}
                                                        </h4>

                                                        <span class="appointment-label">
                                                            {{ $t('message.nomEtablissement') }}
                                                        </span>
                                                        <h4>{{ bill.name }}</h4>
                                                    </div>
                                                    <div class="col-lg-3">
                                                        <span class="appointment-label">
                                                            {{ $t('message.price') }}
                                                        </span>
                                                        <h4>{{ bill.price }}</h4>
                                                    </div>
                                                    <div class="col-lg-3">
                                                        <span :class="'medsur-custom-badge inverted ' + getStatusClass(bill.status)">
                                                            {{ bill.status }}
                                                        </span>
                                                        <br>
                                                        <br>
                                                        <b-button
                                                                variant="primary"
                                                                class="mb-2"
                                                                size="sm"
                                                                @click="onShowBillClick(bill.slug)"
                                                                v-if="can || hasSouscripteurRole"
                                                        >
                                                            {{ $t('message.consult') }}
                                                        </b-button>
                                                        <b-button
                                                                variant="outline-primary"
                                                                size="sm"
                                                                class="mb-2"
                                                                @click="onEditBillClick(bill.slug)"
                                                        >
                                                            {{ $t('message.edit') }}
                                                        </b-button>
                                                        <!--<b-dropdown
                                                                dropdown
                                                                text="action"
                                                                variant="primary"
                                                                class="mt-2"
                                                                size="sm"
                                                        >

                                                            <b-dropdown-item
                                                                    href="#"
                                                                    @click="onShowBillClick(bill.slug)"
                                                                    v-if="can || hasSouscripteurRole"
                                                            >
                                                                {{ $t('message.show') }}
                                                            </b-dropdown-item>
                                                            <b-dropdown-item
                                                                href="#"
                                                                @click="showCancelModal(appointment, 'cancel')"
                                                         v-if="can"
                                                            >
                                                                {{ $t('message.edit') }}
                                                            </b-dropdown-item>
                                                            <b-dropdown-item
                                                            v-if="can"
                                                                    href="#"
                                                                    @click="showCancelModal(appointment, 'delete')"
                                                            >
                                                                {{ $t('message.delete') }}
                                                            </b-dropdown-item>
                                                        </b-dropdown>-->
                                                    </div>
                                                    <span
                                                            class="appointment-item-status-mobile --danger"
                                                            :class="'appointment-item-status-mobile ' + getStatusClass(bill.status)"
                                                    >
                                                            <span class="badge badge-success">
                                                                {{bill.status}}
                                                            </span>
                                                        </span>
                                                </div>
                                            </template>

                                            <template v-else>
                                                <h4>{{ $t('message.noItemToDisplay') }}</h4>
                                            </template>

                                        </div>
                                    </div>
                                    <div class="row appointment-table-footer">

                                    </div>
                                </section>
                            <!-- </b-col> -->
                        </b-row>
                    </b-container>
                <!-- </div> -->

        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import _ from "lodash";
    import moment from "moment";
    import { pagination, handlePaginationClick } from "../../helpers/paginations";
	import { displayNumber } from "../../helpers/general";

    export default {
        name: "List",

        computed: {
            ...mapGetters(['hasAdminRole',"userInstitutions",
                'hasGestionnaireRole','hasMedecinControleRole','hasSouscripteurRole','isComptable','hasAssistante']),

            can: function () {
                return this.hasAdminRole || this.hasGestionnaireRole || this.hasMedecinControleRole || this.isComptable || this.hasAssistante;
            },

            factureColumns: function () {
                return [
                    {
                        label: this.$i18n.t('message.nomEtablissement'),
                        field: 'nom',
                    },
                    {
                        label: this.$i18n.t('message.nomPatient'),
                        field: 'patient',
                    },
                    {
                        label: this.$i18n.t('message.price'),
                        field: 'prix',
                    },
                    {
                        label: this.$i18n.t('message.dateFacturation'),
                        field: 'date',
                    },
                    {
                        label: this.$i18n.t('message.status'),
                        field: 'status',
                    }
                ];
            },

            factureRows: function() {
                let fArray = [];
                let self = this;
                _.forEach(this.userInstitutions, function(institution) {
                    let f = {};

                    _.forEach(institution.factures, function (facture) {
                        if(!_.isNull(facture.dossier)){
                            let nom = facture.dossier.patient.user.nom + ' ' + (_.isNull(facture.dossier.patient.user.prenom) ? '' :facture.dossier.patient.user.prenom);
                            f.nom = institution.name;
                            f.slug = facture.slug;
                            f.patient = nom;
                            f.prix = facture.total_avec_remise;
                            f.date = moment(facture.date_facturation).format('YYYY-MM-DD');
                            f.status = facture.statut;
                            if (self.hasSouscripteurRole){
                                if (['Validé','Rejeté','Archivé','En recouvrement'].includes(f.status)){
                                    if (_.isUndefined(_.find(fArray,function (facture) {
                                        return facture.slug == f.slug;
                                    }))){
                                        fArray.push(f);
                                    }
                                }
                            }else{
                                if (_.isUndefined(_.find(fArray,function (facture) {
                                    return facture.slug == f.slug;
                                }))){
                                    fArray.push(f);
                                }
                            }
                        }
                    })

                });
                return fArray;
            },
        },

        data(){
            return {
                paginationOptions: {
                    enabled: true,
                    mode: 'records',
                    perPageDropdown: [3, 6, 10]
                },
                bills: [],
                filterCriteria: '',
                paginationObject: {},
            }
        },

        watch: {
            userInstitutions: function (newValue, oldValue) {
                const fArray = [];
                // let self = this;
                _.forEach(newValue, function(institution) {
                    
                    _.forEach(institution.factures, function (facture) {
                        const f = {};
                        if(!_.isNull(facture.dossier)) {
                            if (!_.isNull(facture.dossier.patient.user)) {
                            const name = facture.dossier.patient.user.nom + ' ' + (_.isNull(facture.dossier.patient.user.prenom) ? '' : facture.dossier.patient.user.prenom);
                            f.name = institution.name;
                            f.slug = facture.slug;
                            f.patientName = name;
                            let total = 0;
                            _.forEach(facture.prestations,function (prestation){
                              if (prestation.statut == 'Validé'){
                                total = total + prestation.prestation_etablissement.prix - prestation.prestation_etablissement.reduction;
                              }
                          })
                            f.price = total;
                            f.billDate = facture.date_facturation;
                            f.medicalFileSlug = facture.dossier.slug;
                            f.date = moment(facture.date_facturation).format('YYYY-MM-DD');
                            f.status = facture.statut;
                            if (self.hasSouscripteurRole){
                                if (['Validé','Rejeté','Archivé','En recouvrement'].includes(f.status)){
                                    if (_.isUndefined(_.find(fArray,function (facture) {
                                            return facture.slug == f.slug;
                                    }))){
                                        fArray.push(f);
                                    }
                                }
                            }else{
                                if (_.isUndefined(_.find(fArray,function (facture) {
                                    return facture.slug == f.slug;
                                }))){
                                    fArray.push(f);
                                }
                            }
                          }
                        }
                    });
                });

                this.bills = fArray;
            },

            bills: function (newValue, oldValue) {
                this.paginationObject = pagination(newValue);
            },

            filterCriteria: function (newValue, oldValue) {
                this.handleFilter(newValue);
            }
        },

        methods:{
            onShowBillClick(slug) {
                this.$router.push({ name: 'facture', params: { facture: slug } });
            },

			onEditBillClick(slug) {
				this.$router.push({ name: 'edit-facture', params: { facture: slug } });
			},

            onGoToMedicalFile(slug) {
                this.$router.push({ name: 'medical-file', params: { file: slug } });
            },

            getUserInstitutions() {
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };

                this.$store.dispatch('getUserInstitutions', { args : args });
            },

            handleOnAddBill() {
                this.$router.push({ name: 'add-facture' });
            },

            _handlePaginationClick(action) {
                this.paginationObject = handlePaginationClick(action, {...this.paginationObject});
            },

            billDate(date, type) {
                switch (type) {
                    case 'date': return moment(date).format('ddd, Do MMM YYYY');
                    case 'hour': return moment(date).format('HH:mm');
                }
            },

            getStatusClass(status) {
                if (status === 'Archivé' || status === 'Archiver') return '--warning';
                else if (status === 'Rejeté' || status === 'Rejeter') return '--danger';
                else if (status === 'En recouvrement') return '--dark';
                else return '--success';
            },

            handlerOnFilterButton() {
                event.preventDefault();
                this.handleFilter(this.filterCriteria);
            },

            handleFilter(value) {
                if (value) {
                    const newBills = this.bills.filter(app => {
                        let result = false;

                        if (app.price) {
                            result = result || app.price.toLowerCase().includes(value.toLowerCase());
                        }

                        if (app.nom) {
                            result = result || app.patient.nom.toLowerCase().includes(value.toLowerCase());
                        }

                        if (app.billDate && this.billDate(app.billDate, 'date')) {
                            result = result || this.billDate(app.billDate, 'date').toLowerCase().includes(value.toLowerCase());
                        }

                        if (app.billDate && this.billDate(app.billDate, 'hour')) {
                            result = result || this.billDate(app.billDate, 'hour').toLowerCase().includes(value.toLowerCase());
                        }

                        return result;
                    });

                    this.paginationObject = pagination(newBills, 2);
                } else {
                    this.paginationObject = pagination(this.bills, 2);
                }
            },

			_displayNumber: displayNumber,
        },

        mounted() {
            this.getUserInstitutions();
        }
    }
</script>

<style scoped>

</style>
